import { jsx as _jsx } from "react/jsx-runtime";
import MUIFormHelperText from '@material-ui/core/FormHelperText';
import cn from 'classnames';
import withStyles from '../withStyles';
import styles from './InputHelperText.styles';
const HelperText = ({ className, error, success, disabled, indent, children, classes, }) => (_jsx(MUIFormHelperText, Object.assign({ className: cn(classes.root, indent && classes.indent, success && classes.success, className), classes: { error: classes.error }, error: error, disabled: disabled }, { children: children })));
export default withStyles(styles)(HelperText);
//# sourceMappingURL=InputHelperText.js.map